import { format } from 'date-fns';
import { get, pickBy, uniqBy } from 'lodash';
import qs from 'qs';

type GroupsType = {
  [key: string]: any;
};

export const groupTasksByDate = tasks => {
  const groups: GroupsType = {
    withoutStartedAtDate: [],
    byDates: {},
  };

  tasks.forEach(task => {
    if (!task.startedAt) {
      groups.withoutStartedAtDate.push(task);
      return;
    }

    const formattedDate = format(new Date(task.startedAt), 'dd.MM.yyyy');

    if (Object.keys(groups.byDates).includes(formattedDate)) {
      groups.byDates[formattedDate].push(task);
    } else {
      groups.byDates[formattedDate] = [task];
    }
  });

  return groups;
};

export const generateTasksBackendParams = data => {
  const queryFields = {
    page: get(data, 'page'),
    size: get(data, 'size'),
    author_id: get(data, 'authorId'),
    summonees: get(data, 'summonees'),
    priority: get(data, 'priority'),
    tag_ids: get(data, 'tagIds'),
    skill_group_id: get(data, 'skillGroupId'),
    status: get(data, 'status'),
    id: get(data, 'id'),
    assignee_id: get(data, 'assigneeId'),
    started_at_from: get(data, 'startedAtFrom'),
    started_at_to: get(data, 'startedAtTo'),
    ended_at_from: get(data, 'endedAtFrom'),
    ended_at_to: get(data, 'endedAtTo'),
  };

  return pickBy(queryFields, v => v !== undefined);
};

export const generateQueryFetchTasks = data => {
  const params = generateTasksBackendParams(data);

  return qs.stringify(params, { arrayFormat: 'brackets' });
};

export const buildFilters = rawFilters => {
  if (!rawFilters || Object.keys(rawFilters).length === 0) return undefined;
  return generateTasksBackendParams(rawFilters);
};
